import { Suspect, Phase } from "../types";

interface Props {
  suspect: Suspect;
  phase: Phase;
  selectedSuspect: string | null;
  onSelect: (id: string) => void;
}

export default function SuspectCard({ suspect, phase, selectedSuspect, onSelect }: Props) {
  const isSelected = selectedSuspect === suspect.id;
  const isRevealed = phase === "revealed";

  const classes = [
    "suspect-card",
    isSelected && phase === "reading" ? "selected" : "",
    isRevealed && suspect.guilty ? "revealed-guilty" : "",
    isRevealed && !suspect.guilty ? "eliminated" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={classes}
      onClick={() => phase === "reading" && onSelect(suspect.id)}
    >
      <div className="suspect-header">
        <div>
          <div className="suspect-name">{suspect.name}</div>
          <div className="suspect-role">{suspect.role}</div>
        </div>

        {isRevealed && (
          <span className={`suspect-tag ${suspect.guilty ? "guilty" : ""}`}>
            {suspect.guilty ? "GUILTY" : "CLEARED"}
          </span>
        )}

        {!isRevealed && isSelected && (
          <span
            className="suspect-tag"
            style={{ borderColor: "var(--gold)", color: "var(--gold)" }}
          >
            ACCUSED
          </span>
        )}
      </div>

      <p className="suspect-statement">"{suspect.statement}"</p>
    </div>
  );
}
